export default __webpack_public_path__ + "static/3-8fb5bf55cf1363c55274e82d20c5872d.jpg";